<template>
  <b-card class="no-border animated">
    <div class="item-header clearfix mb-3">
      <h5 class="pull-left mb-0 mt-2">{{displayName}}</h5>
      <div v-if="canIEditVehicle(detailedInfo)" class="pull-right">
        <b-button variant="outline-primary" @click="section = 'edit'" v-if="section === ''"><i class="fa fa-pencil-square-o"></i>&nbsp; Edit</b-button>
      </div>
    </div>
    <div class="list-group mb-2">
      <b-nav>
        <b-nav-item @click="section = ''"            :active="section === ''"           >Preview</b-nav-item>
        <b-nav-item @click="section = 'gps_devices'" :active="section === 'gps_devices'">GPS Devices</b-nav-item>
        <b-nav-item @click="section = 'additional'"  :active="section === 'additional'" >Additional Data</b-nav-item>
        <b-nav-item @click="section = 'prestart_checklist_vehicle'"  :active="section === 'prestart_checklist_vehicle'" >Prestart Checklist</b-nav-item>
        <b-nav-item @click="section = 'user'"        :active="section === 'user'">User</b-nav-item>
      </b-nav>
    </div>
    <router-view></router-view>
  </b-card>
</template>
<script>
import vehicleMixin from '@/mixins/vehicle';

export default {
  name: 'vehicle_detail',
  mixins: [vehicleMixin],
  data() {
    const routes = this.$route.fullPath.split('/');
    return {
      section: routes[4] || '',
      loaded: false,
    };
  },
  created() {
    const { vehicleId } = this.$route.params;
    this.$store.commit('vehicles/SET_DETAIL_ID', vehicleId);
    this.$store.commit('SET_BREADCRUMB_ITEMS', [
      { to: '', name: 'Home' },
      { to: 'admin', name: 'Admin' },
      { to: 'vehicles', name: 'Vehicles' },
      { to: vehicleId, name: 'Detail' },
    ]);
  },
  computed: {
    detailedInfo() {
      return this.$store.getters['vehicles/get_detail_data'];
    },
    displayName() {
      return this.detailedInfo.reg_no;
    },
  },
  watch: {
    section(newSection) {
      const { vehicleId } = this.$route.params;
      this.$router.push(`/admin/vehicles/${vehicleId}/${newSection}`);
    },
  },
};
</script>
<style>

</style>




// WEBPACK FOOTER //
// src/views/pages/admin/vehicles/Detail.vue